module.exports = __webpack_public_path__ + "static/media/35.aa608d53.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/35.png
// module id = 996
// module chunks = 0